import { CONTENT } from "@/content";
import { BorderBeam } from "@/components/ui/border-beam";
import { Reveal } from "../ui/Reveal";
import { SecHead } from "./SecHead";
import { motion, type Variants } from "framer-motion";

type Props = { onCTA: () => void };

const diagnosticNumberVariants: Variants = {
  rest: {
    opacity: 0.25,
    rotate: 0,
    scale: 1,
  },
  hover: {
    opacity: 1,
    rotate: -4,
    scale: 1.12,
    transition: { type: "spring", stiffness: 360, damping: 20 },
  },
};

export function Diagnostico({ onCTA }: Props) {
  const d = CONTENT.diagnostico;
  return (
    <section className="section dark diagnostico" id="diagnostico">
      <div className="wrap">
        <SecHead label={d.label} title={d.title} intro={d.intro} dark align="split" />

        <div className="diag-pro-list">
          {d.steps.map(([k, v], i) => (
            <motion.div 
              className="diag-pro-step"
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover="hover"
              viewport={{ once: true, margin: "-10%" }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            >
              <motion.div className="diag-pro-num" initial="rest" variants={diagnosticNumberVariants}>
                {String(i + 1).padStart(2, '0')}
              </motion.div>
              <div className="diag-pro-content">
                <h3 className="diag-pro-title">{k}</h3>
                <p className="diag-pro-desc">{v}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <Reveal className="diag-foot">
          <p className="diag-closing serif">{d.closing}</p>
          <button className="btn btn-gold btn-lg btn-beam btn-beam-gold" onClick={onCTA}>
            <BorderBeam />
            {d.cta} <span className="arr">→</span>
          </button>
        </Reveal>
      </div>
    </section>
  );
}
